import { Mail } from "lucide-react";
import { useTranslation } from "react-i18next";

const NoEmails = () => {
    const { t } = useTranslation();

    return (
        <div
            className="text-text-secondary flex max-w-sm flex-col items-center justify-center gap-3 text-center"
            role="status"
        >
            <Mail aria-hidden className="h-8 w-8 shrink-0" />
            <span className="text-text-main-title text-sm font-medium">
                {t("emails.noMailsFound")}
            </span>
        </div>
    );
};

export default NoEmails;
